// Copyright (c) Microsoft Corporation.
// Licensed under the MIT License.

import type { OperationOptions } from "@azure-rest/core-client";

/** Optional parameters. */
export interface MaintenanceConfigurationsListByManagedClusterOptionalParams extends OperationOptions {}

/** Optional parameters. */
export interface MaintenanceConfigurationsDeleteOptionalParams extends OperationOptions {}

/** Optional parameters. */
export interface MaintenanceConfigurationsCreateOrUpdateOptionalParams extends OperationOptions {}

/** Optional parameters. */
export interface MaintenanceConfigurationsGetOptionalParams extends OperationOptions {}
